import { render, staticRenderFns } from "./Incident.vue?vue&type=template&id=2d23d44a&scoped=true"
import script from "./Incident.vue?vue&type=script&lang=js"
export * from "./Incident.vue?vue&type=script&lang=js"
import style0 from "./Incident.vue?vue&type=style&index=0&id=2d23d44a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d23d44a",
  null
  
)

export default component.exports